export default [
  {
    Id: 139,
    Name: "SSD 4 TB",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 1350,
    Dollar: 355,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 138,
    Name: "22",
    Num_of_books: 10000,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 0,
    Dollar: 0,
    Version: 22,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 137,
    Name: "אור לישרים",
    Num_of_books: 600,
    Product_level: 2,
    Last_updated: "2024-01-05T22:00:00.000Z",
    Active: 1,
    Nis: 600,
    Dollar: 175,
    Version: 22,
    Product_key: "YESHARIM",
    Package_version: 22,
    UserRightID: 524288,
    Type: null,
  },
  {
    Id: 136,
    Name: "עוז והדר - הרחבה",
    Num_of_books: 400,
    Product_level: 2,
    Last_updated: "2024-01-03T22:00:00.000Z",
    Active: 1,
    Nis: 390,
    Dollar: 120,
    Version: 19,
    Product_key: "OZ_NEW",
    Package_version: 19,
    UserRightID: 1048576,
    Type: null,
  },
  {
    Id: 135,
    Name: "SSD 2TB",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 580,
    Dollar: 150,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 133,
    Name: "דיסק 4 טרה",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 500,
    Dollar: 125,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 132,
    Name: "אחר",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "2023-01-24T22:00:00.000Z",
    Active: 1,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "other",
  },
  {
    Id: 131,
    Name: "מקוון קבוע לשנה",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 450,
    Dollar: 130,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "other",
  },
  {
    Id: 130,
    Name: "21",
    Num_of_books: 8000,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 127,
    Name: "מאור ישראל",
    Num_of_books: 600,
    Product_level: 2,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 600,
    Dollar: 175,
    Version: 21,
    Product_key: "OVADIA",
    Package_version: 21,
    UserRightID: 262144,
    Type: null,
  },
  {
    Id: 126,
    Name: 'שליחות הו"ח איצקוביץ ',
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 80,
    Dollar: 25,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "post",
  },
  {
    Id: 125,
    Name: "4 טרה טייפ C",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 230,
    Dollar: 68,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 124,
    Name: "הפרשי שדרוגים ",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 190,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 123,
    Name: "הפרש לעדכון גרסה",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 70,
    Dollar: 23,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 122,
    Name: "שליחות שטארק הלוך ושוב ",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 70,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "post",
  },
  {
    Id: 121,
    Name: "הפרש לדיסק 4 טרה",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 155,
    Dollar: 40,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "fees",
  },
  {
    Id: 120,
    Name: "משלוח פדאקס",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 110,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "post",
  },
  {
    Id: 119,
    Name: "דמי טיפול  מ11 ומטה ",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 210,
    Dollar: 63,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "fees",
  },
  {
    Id: 118,
    Name: "הפרש לדיסק 4 טרה C",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 230,
    Dollar: 68,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 117,
    Name: "20",
    Num_of_books: 8000,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 114,
    Name: "דיסק חיצוני 750GB",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 160,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 113,
    Name: "דמי טיפול 40 שח",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 40,
    Dollar: 12,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "fees",
  },
  {
    Id: 112,
    Name: "מעבר מספריה לחיפוש",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 800,
    Dollar: 270,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "other",
  },
  {
    Id: 111,
    Name: "רשת מפרשי האוצר",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 1630,
    Dollar: 509,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "network",
  },
  {
    Id: 109,
    Name: "עמלת טיפול",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 45,
    Dollar: 14,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "fees",
  },
  {
    Id: 108,
    Name: "עדכון גירסא 6 ומטה",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 190,
    Dollar: 63,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "other",
  },
  {
    Id: 106,
    Name: "19",
    Num_of_books: 5000,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 105,
    Name: "אונקי עם אחריות שנה",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 104,
    Name: "דיסק מהבית",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 103,
    Name: "אונקי חבד",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 200,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 102,
    Name: "עמלת אונקי אבד/נגנב",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 70,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "fees",
  },
  {
    Id: 101,
    Name: "עמלת  דיסק אבד/נגנב",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 400,
    Dollar: 120,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "fees",
  },
  {
    Id: 100,
    Name: "שדרוג ע.רשת",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 80,
    Dollar: 24,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "network",
  },
  {
    Id: 99,
    Name: "שליחות לחול רשום",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 140,
    Dollar: 40,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "post",
  },
  {
    Id: 98,
    Name: "שליחות הוריקן כפול",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 90,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "post",
  },
  {
    Id: 97,
    Name: "שליחות הוריקן",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 45,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "post",
  },
  {
    Id: 96,
    Name: "בני תורה למלא",
    Num_of_books: null,
    Product_level: 6,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 800,
    Dollar: 220,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 95,
    Name: "אונקי חדש",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 50,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "onKey",
  },
  {
    Id: 94,
    Name: "הפרש עדכון",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 100,
    Dollar: 30,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 93,
    Name: "חוט חדש",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 30,
    Dollar: 1,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "other",
  },
  {
    Id: 92,
    Name: "19",
    Num_of_books: 5000,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 90,
    Name: 'מהדורת חב"ד',
    Num_of_books: 8200,
    Product_level: 1,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 990,
    Dollar: 300,
    Version: null,
    Product_key: "CHABHAD",
    Package_version: 19,
    UserRightID: 4,
    Type: null,
  },
  {
    Id: 89,
    Name: "פלאג",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 160,
    Dollar: 106,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 87,
    Name: "דיסק חדש עם אחריות",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 86,
    Name: "דיסק חדש",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 330,
    Dollar: 85,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "disk",
  },
  {
    Id: 84,
    Name: "0",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 83,
    Name: "1",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 82,
    Name: "2",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 81,
    Name: "3",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 80,
    Name: "4",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 79,
    Name: "5",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 78,
    Name: "6",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 77,
    Name: "7",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 76,
    Name: "8",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 75,
    Name: "9",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 74,
    Name: "10",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 10,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 73,
    Name: "11",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 11,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 72,
    Name: "12",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 12,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 71,
    Name: "13",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 13,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 70,
    Name: "14",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 14,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 69,
    Name: "15",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 15,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 68,
    Name: "16",
    Num_of_books: null,
    Product_level: 4,
    Last_updated: "0000-00-00",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 16,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 67,
    Name: "אוצר מפרשי התלמוד",
    Num_of_books: 50,
    Product_level: 2,
    Last_updated: "2020-09-11T21:00:00.000Z",
    Active: 1,
    Nis: 100,
    Dollar: 30,
    Version: null,
    Product_key: "OTZAR_MEFHARSHI_HATLMOD",
    Package_version: 19,
    UserRightID: 16384,
    Type: null,
  },
  {
    Id: 65,
    Name: "5",
    Num_of_books: 0,
    Product_level: 5,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 1990,
    Dollar: 603,
    Version: 5,
    Product_key: "21",
    Package_version: 18,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 64,
    Name: "4",
    Num_of_books: 0,
    Product_level: 5,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 1800,
    Dollar: 545,
    Version: 4,
    Product_key: "21",
    Package_version: 18,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 63,
    Name: "3",
    Num_of_books: 0,
    Product_level: 5,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 1685,
    Dollar: 510,
    Version: 3,
    Product_key: "19.0-22.0",
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 60,
    Name: "2",
    Num_of_books: 0,
    Product_level: 5,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 1390,
    Dollar: 421,
    Version: 2,
    Product_key: "20.0-22.0",
    Package_version: 20,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 59,
    Name: "1",
    Num_of_books: 0,
    Product_level: 5,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 740,
    Dollar: 224,
    Version: 1,
    Product_key: "21.0-22.0",
    Package_version: 21,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 27,
    Name: "מהדורה מלאה",
    Num_of_books: 97200,
    Product_level: 1,
    Last_updated: "0000-00-00",
    Active: 1,
    Nis: 7200,
    Dollar: 1990,
    Version: 18,
    Product_key: "ALL",
    Package_version: 19,
    UserRightID: 1,
    Type: null,
  },
  {
    Id: 21,
    Name: "מפרשי האוצר",
    Num_of_books: 20000,
    Product_level: 2,
    Last_updated: "2020-07-21T21:00:00.000Z",
    Active: 1,
    Nis: 1830,
    Dollar: 530,
    Version: 1,
    Product_key: "MEF_OTZAR",
    Package_version: 19,
    UserRightID: 2048,
    Type: null,
  },
  {
    Id: 20,
    Name: "17",
    Num_of_books: 10000,
    Product_level: 4,
    Last_updated: "2019-08-01T21:00:00.000Z",
    Active: 0,
    Nis: 650,
    Dollar: 200,
    Version: 17,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 19,
    Name: "18",
    Num_of_books: 5000,
    Product_level: 4,
    Last_updated: "2020-07-30T21:00:00.000Z",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 18,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 17,
    Name: "עמדת רשת",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "2020-07-27T21:00:00.000Z",
    Active: 1,
    Nis: 800,
    Dollar: 242,
    Version: null,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "network",
  },
  {
    Id: 16,
    Name: "אוצר פנימי",
    Num_of_books: null,
    Product_level: 3,
    Last_updated: "2020-07-28T21:00:00.000Z",
    Active: 1,
    Nis: 160,
    Dollar: 106,
    Version: 0,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: "onKey",
  },
  {
    Id: 15,
    Name: "זכרון אהרן",
    Num_of_books: 150,
    Product_level: 2,
    Last_updated: "2020-07-24T21:00:00.000Z",
    Active: 1,
    Nis: 560,
    Dollar: 165,
    Version: 17,
    Product_key: "AHARON",
    Package_version: 19,
    UserRightID: 4096,
    Type: null,
  },
  {
    Id: 14,
    Name: "עוז והדר",
    Num_of_books: 700,
    Product_level: 2,
    Last_updated: "2020-07-26T21:00:00.000Z",
    Active: 1,
    Nis: 1990,
    Dollar: 577,
    Version: 17,
    Product_key: "OZ",
    Package_version: 19,
    UserRightID: 256,
    Type: null,
  },
  {
    Id: 13,
    Name: 'חב"ד',
    Num_of_books: 7520,
    Product_level: 2,
    Last_updated: "2020-07-26T21:00:00.000Z",
    Active: 1,
    Nis: 320,
    Dollar: 100,
    Version: 17,
    Product_key: "CHABAD",
    Package_version: 19,
    UserRightID: 4,
    Type: null,
  },
  {
    Id: 12,
    Name: "אנציקלופדיה תלמודית",
    Num_of_books: 52,
    Product_level: 2,
    Last_updated: "2020-07-24T21:00:00.000Z",
    Active: 1,
    Nis: 375,
    Dollar: 110,
    Version: 18,
    Product_key: "ENC",
    Package_version: 19,
    UserRightID: 512,
    Type: null,
  },
  {
    Id: 11,
    Name: "מכון אופק",
    Num_of_books: 68,
    Product_level: 2,
    Last_updated: "2020-07-25T21:00:00.000Z",
    Active: 1,
    Nis: 590,
    Dollar: 175,
    Version: 17,
    Product_key: "OFEK",
    Package_version: 19,
    UserRightID: 128,
    Type: null,
  },
  {
    Id: 10,
    Name: "חכמת שלמה",
    Num_of_books: 139,
    Product_level: 2,
    Last_updated: "2020-07-25T21:00:00.000Z",
    Active: 1,
    Nis: 350,
    Dollar: 105,
    Version: 18,
    Product_key: "SHLOMO",
    Package_version: 19,
    UserRightID: 32,
    Type: null,
  },
  {
    Id: 9,
    Name: "אהבת שלום",
    Num_of_books: 613,
    Product_level: 2,
    Last_updated: "2020-07-24T21:00:00.000Z",
    Active: 1,
    Nis: 780,
    Dollar: 230,
    Version: 18,
    Product_key: "SHALOM",
    Package_version: 19,
    UserRightID: 64,
    Type: null,
  },
  {
    Id: 8,
    Name: "מכון ירושלים",
    Num_of_books: 515,
    Product_level: 2,
    Last_updated: "2020-07-24T21:00:00.000Z",
    Active: 1,
    Nis: 1090,
    Dollar: 320,
    Version: 18,
    Product_key: "MACHON",
    Package_version: 19,
    UserRightID: 16,
    Type: null,
  },
  {
    Id: 7,
    Name: "מוסד הרב קוק",
    Num_of_books: 1140,
    Product_level: 2,
    Last_updated: "2020-07-18T21:00:00.000Z",
    Active: 1,
    Nis: 1300,
    Dollar: 380,
    Version: 18,
    Product_key: "KOOK",
    Package_version: 19,
    UserRightID: 8,
    Type: null,
  },
  {
    Id: 6,
    Name: "מהדורת ספריה",
    Num_of_books: 97200,
    Product_level: 1,
    Last_updated: "2020-08-01T21:00:00.000Z",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 9,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 5,
    Name: "מהדורת תורה ומחשבה",
    Num_of_books: 51000,
    Product_level: 1,
    Last_updated: "2020-08-01T21:00:00.000Z",
    Active: 0,
    Nis: 0,
    Dollar: 0,
    Version: 16,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 4,
    Name: "מהדורת גמרא והלכה",
    Num_of_books: 52000,
    Product_level: 1,
    Last_updated: "2020-08-01T21:00:00.000Z",
    Active: 0,
    Nis: 500,
    Dollar: 0,
    Version: 16,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 3,
    Name: 'מהדורת חב"ד',
    Num_of_books: 6500,
    Product_level: 1,
    Last_updated: "2020-07-31T21:00:00.000Z",
    Active: 1,
    Nis: 990,
    Dollar: 300,
    Version: 16,
    Product_key: null,
    Package_version: 19,
    UserRightID: null,
    Type: null,
  },
  {
    Id: 2,
    Name: "מהדורת בני תורה",
    Num_of_books: 91300,
    Product_level: 1,
    Last_updated: "2020-07-26T21:00:00.000Z",
    Active: 1,
    Nis: 6400,
    Dollar: 1770,
    Version: 16,
    Product_key: "BT",
    Package_version: 19,
    UserRightID: 524288,
    Type: null,
  },
];
